import { Component, OnInit } from '@angular/core';
import {Modal, QuestionResult} from '@softline/ui-core';


import { InterpolatePipe } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
    selector: 'lib-confirm-dialog',
    imports: [
    InterpolatePipe,
    TranslatePipe
  ],
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent implements OnInit, Modal<QuestionResult> {

  amount!: number;
  type!: 'redeem' | 'charge';

  close!: (result: QuestionResult) => void;

  constructor() { }

  ngOnInit(): void {}

  registerCloseHandler(handler: (result: QuestionResult) => void): void {
    this.close = handler;
  }
}
